/**
 * External dependencies
 */
import React from "react";
import classnames from "classnames";
import { Box } from "@towersystems/towersystems-design-system";
import { SlSettings } from "react-icons/sl";
import { CiMenuKebab } from "react-icons/ci";

/**
 * Internal dependencies
 */
import DropdownLink from "components/dropdown-link";

const ReportActions = ({ className, actions, name }) => {
  const classes = classnames("report__report-actions");

  return (
    <Box className={classes}>
      <DropdownLink
        title={<CiMenuKebab size={24} />}
        showArrow={false}
        items={actions}
        labelClassNames="text-sm text-gray-400"
      />
    </Box>
  );
};

export default ReportActions;
